
export const departmentConstants = {
    GET_SUCCESS: 'GET_DEPARTMENT_SUCCESS',

    ADD_SUCCESS: 'ADD_DEPARTMENT_SUCCESS',
    ADD_FAILURE: 'ADD_DEPARTMENT_FAILURE',

    DELETE_SUCCESS: 'DELETE_DEPARTMENT_SUCCESS',
    DELETE_FAILURE: 'DELETE_DEPARTMENT_FAILURE',

    UPDATE_SUCCESS: 'UPDATE_DEPARTMENT_SUCCESS',
    UPDATE_FAILURE: 'UPDATE_DEPARTMENT_FAILURE',

    CLEAR_ERROR: 'CLEAR_DEPARTMENT_ERROR_CODE'
};
